const themeStyles = colors => {
  const styles = {
    form: {
      display: 'flex',
      flexDirection: 'column'
    },
    title: {
      color: colors.lightGray,
      fontFamily: 'Barlow',
      fontSize: 30,
      fontWeight: 700,
      lineHeight: '34px',
      textAlign: 'center',
      marginBottom: 30
    },
    button: {
      button: {
        margin: '0 auto 0 auto',
        display: 'block',
        width: '290px',
        marginTop: '26px'
      }
    }
  }
  return styles
}

export default themeStyles
